<template>
<v-app class="ma-0 pa-0">
    <div id="app">
      <ebm-header/>
        <div class="hero_section">
            <img src="@/assets/header_logo.png" class="hero_content">
            <p class="hero_content1" >專人到府將你的醫療影像送到醫師手上 安全待在家也能看診</p>
            <div class="blue_button"  @click="$vuetify.goTo('#scrollhere')">
                <p class="hero_content2" >了解更多</p>
            </div>
            <img src="@/assets/main_background.png" class="hero_img">
        </div>
        <div class="cd_question" id="scrollhere">
        <v-row>
            <v-col class="pa-1">
                <div class=" float-r">
                <img src="@/assets/hos1.png" class="hos_image">
                </div>
            </v-col>
            <v-col class="pa-1">
                <div class="courier_content">
                <img src="@/assets/hos2.png" class="hos_image">
                </div>
            </v-col>
            <v-col class="pa-1">
                <div class=" float-l">
                <img src="@/assets/hos3.png" class="hos_image">
                </div>
            </v-col>
        </v-row>
        </div>
        <div class="courier_block">
        <p class="courier_title">透過快遞服務, 我們協助您</p>
        <v-row>
            <v-col>
                <div class="courier_step float-r">
                <img src="@/assets/medical_cd/cd_user.png" class="courier_image">
                <p class="courier_text">將醫療光碟轉交給指定對象</p>
                </div>
            </v-col>
            <v-col>
                <div class="courier_step">
                <img src="@/assets/medical_cd/cd_phone.png" class="courier_image">
                <p class="courier_text">光碟影像轉入個人行動裝置</p>
                </div>
            </v-col>
            <v-col>
                <div class="courier_step float-l">
                <img src="@/assets/medical_cd/hand_cd.png" class="courier_image">
                <p class="courier_text">委託代辦光碟申請相關事務</p>
                </div>
            </v-col>
        </v-row>
        </div>
        <div class="choose">
            <div class="choose_grey">
            <v-row>
                <v-col>
                    <p class="choose_text">為什麼選擇光碟快遞服務?</p>
                    <img src="@/assets/medical_cd/whychooseus.png"  class="chooseus_img">
                </v-col>
                <v-col >
                    <div class="choose_card mt-107" >
                    <img class="choose_img" src="@/assets/medical_cd/SVG/time.svg">
                    <p class="choose_card_text">省下掛號排隊時間</p>
                    </div>
                    <div class="choose_card mt-30">
                        <img class="choose_img" src="@/assets/medical_cd/SVG/hand stop.svg">
                    <p class="choose_card_text">降低接觸感染風險</p>
                    </div>
                    <div class="choose_card mt-30">
                        <img class="choose_img" src="@/assets/medical_cd/SVG/secure.svg">
                    <p class="choose_card_text">安全、專業、及時</p>
                    </div>
                </v-col>
            </v-row>
            </div>
        </div>
        <div class="advantage">
            <p class="advantage_text1">光碟影像存放個人行動裝置</p>
            <p class="advantage_text2">3</p>
            <p class="advantage_text3">大優勢</p>
        </div>
        <v-row>
            <v-col >
                <div class="advantage_card ad1 float-r">
                <img src="@/assets/medical_cd/use_phone.png" class="adv_image">
                <p class="advantage_text">需要時隨時瀏覽或分享</p>
                </div>
            </v-col>
            <v-col align="center">
                <div class="advantage_card">
                <img src="@/assets/medical_cd/infi_folder.png" class="adv_image">
                <p class="advantage_text">永久保存</p>
                </div>
            </v-col>
            <v-col>
                <div class="advantage_card ad2 float-l">
                <img src="@/assets/medical_cd/tree_folder.png" class="adv_image">
                <p class="advantage_text">集中管理, 減少遺失風險</p>
                </div>
            </v-col>
        </v-row>
        <div class="fee">
            <p class="fee_title">服務費用</p>
            <div class="fee_free">
                <p class="fee_pro">推廣期間</p>
                <p class="fee_pro1">免費</p>
            </div>
            <v-row>
                <v-col cols="2">
                </v-col>
                <v-col cols="2">
                    <v-card
                    class="card"
                    max-width="260"
                    outlined
                    >
                    <v-list-item three-line align="center">
                    <v-list-item-content>
                        <div class="card_title">
                        單趟
                        </div>
                        <v-list-item-title class="card_content">
                        $100
                        </v-list-item-title>
                        <v-list-item-subtitle class="card_subtitle">
                        /小時</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="2">
                    <v-card
                    class="card"
                    max-width="260"
                    outlined
                    >
                    <v-list-item three-line align="center">
                    <v-list-item-content>
                        <div class="card_title">
                        跨縣市
                        </div>
                        <v-list-item-title class="card_content">
                        $100
                        </v-list-item-title>
                        <v-list-item-subtitle class="card_subtitle">
                        /小時</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="2">
                    <v-card
                    class="card"
                    max-width="260"
                    outlined
                    >
                    <v-list-item three-line align="center">
                    <v-list-item-content>
                        <div class="card_title">
                        掛號/報到
                        </div>
                        <v-list-item-title class="card_content">
                        $200
                        </v-list-item-title>
                        <v-list-item-subtitle class="card_subtitle">
                        /次</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="2">
                    <v-card
                    class="card"
                    max-width="260"
                    outlined
                    >
                    <v-list-item three-line align="center">
                    <v-list-item-content>
                        <div class="card_title">
                        緊急
                        </div>
                        <v-list-item-title class="card_content">
                        $100
                        </v-list-item-title>
                        <v-list-item-subtitle class="card_subtitle">
                        /小時</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="2">
                </v-col>
            </v-row>
        </div>
        <div class="hospital_block">
            <div class="hospital_outline">
            <v-row align="right">
                <v-col cols="6">
                    <img src="@/assets/medical_cd/hospital.png" class="hospital_image">
                </v-col>
                <v-col cols="6">
                <p class="hospital_title">合作據點</p>
                <div class="hospital_list">
                    <div class="hospital_scroll">
                    <div v-for="hospital in hospitalNames" :key="hospital.id" class="hospitalNames2" >
                        <p class="hospital_name">{{hospital.nameChinese}}</p>
                    </div>
                    </div>
                </div>
                </v-col>
            </v-row>
            </div>
        </div>
        <contact-form></contact-form>
        <ebm-footer/>
    </div>
</v-app>
</template>
<script>
import axios from 'axios'
import ContactForm from './ContactForm.vue'
import EbmHeader from './EbmHeader.vue'
import EbmFooter from './EbmFooter.vue'
export default {
    metaInfo() {
        return { 
            title: "CD to Mobile",
        }
    },
    data(){
        return{
            hospitalNames:[],
            dialog: false,
        }
    },
    created(){
    axios.get('https://fhrweb.ebmtech.com/net/api/Hlists')
    .then(
        res => this.hospitalNames=res.data
        )
    .catch(error=>{
      console.log(error);
    })
    },
    methods:{
        openContactForm(){
            this.dialog =true
        }
    },
    components:{
        ContactForm,
        EbmHeader,
        EbmFooter
    }
}
</script>
<style scoped>
.mt-30{
    margin-top: 30px;
}
.mt-107{
    margin-top: 107px;
}
.adv_image{
    height:241px;
    width:auto;
}
.courier_image{
    height:191px; width:auto;
}
.hospital_image{
    height:545px;
    width:auto;
    float:right;
    margin-top:185px;
    margin-right: 50px;
}
.chooseus_img
{
    height: 640px;
    width: auto;
 margin-left:254px;
}
.hos_image{
    height:380px; 
    width:525px;
}
.hero_img{
    height:992px; 
    width:100%
}
.cd_question{
    margin-top: 12px;
    height: 400px;
    width: 100%;
    background: #F8F8F8 0% 0% no-repeat padding-box;
}
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap');

.form_block{
    height: 604px;
}
.float-r{
    float:right;
}
.float-l{
    float:left;
}
.contact_title3{
    font-size: 20px;
    color: #2A2F35;
}
.contact_title2{
    margin-top: 13px;
    font-size: 20px;
    color: #2A2F35;
}
.contact_title1{
    color: #2A2F35;
    margin-top: 50px;
}
.contact_block{
    height: 207px;
    background: #F8F8F8 0% 0% no-repeat padding-box;
}
.hospital_name{
    color: #707070;
    padding-top: 23px;
    font-size: 20px;
}
.hospital_scroll{
  height: 648px;
  overflow:auto;
}
.hospitalNames2{
  height:75px;
  margin-left: 32px;
  margin-right: 33px;
  border-bottom: 1px solid #707070;;
}
.hospital_list{
    width: 786px;
    height: 648px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 30px #00000029;
    border-radius: 10px;
    margin-top: 36px;
    }
.hospital_outline{
    background: linear-gradient(170deg, #E7F3F5, #E7F3F5 60%, white 60%, white);
    height: 557px;
}
.hospital_title{
    color: #2A2F35;
    font-size: 36px;
    font-weight: bold;
    margin-top: 80px;
}
.hospital_block{
    height: 906px;
}
.card_subtitle{
    color: #828282;
    font-size: 20px;
    padding-top: 44px;
}
.card_content{
    color: #012E81;
    font-size: 36px;
    font-weight: bold;
    padding-top: 36px;
}
.card_title{
    color: #2A2F35;
    font-size: 20px;
    padding-top: 68px;
}
/* .card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
} */
.card{
    border: 2px solid #CCCCCC;
    border-radius: 10px;
    transition: 0.2s;
    height: 302px;
}
.fee_pro1{
    color: #00BEFF;
    font-size: 60px;
    padding-left: 304px;
    padding-top: 16px;
    display: inline-block;
    position: absolute;
    font-weight: bold;
}
.fee_pro{
    /* position: absolute; */
    color: #012E81;
    font-size: 28px;
    padding-left: 68px;
    padding-top: 38px;
    display: inline-block;
}
.fee_free{
    margin:auto;
    margin-top: 80px;
    margin-bottom: 58px;
    width: 1088px;
    height: 115px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 30px #00000029;
    border-radius: 58px;
    opacity: 1;
}
.fee_title{
    color: #2A2F35;
    font-size: 36px;
    font-weight: bold;
    padding-left: 140px;
    padding-top: 202px;
}
.fee{
    height: 917px;
    width: 100%;
    color: white;
}
.advantage_text{
    font-size:28px; 
    color:#2A2F35;
    margin-top: 15px;
    }
.ad1{
    margin-left: 170 !important;
}
.ad2{
    margin-right: 170 !important;
}
.advantage_card{
    text-align: center;
    margin-top:84px; 
    height: 365px;
    width: 397px;
    padding-top: 32px;
    background-color: #E7F3F5;
}
/* .advantage_card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
} */
.advantage_text3{
    display: inline-block;
    color: #012E81;
    text-shadow: 0px 3px 30px #00000029;
    font-size: 36px;
    font-weight: bold;
}
.advantage_text2{
    display: inline-block;
    color: #012E81;
    text-shadow: 0px 3px 30px #00000029;
    font-size: 100px;
    margin-left: 25px;
    margin-right: 12px;
    vertical-align: middle;
}
.advantage_text1{
    display: inline-block;
    color: #012E81;
    text-shadow: 0px 3px 30px #00000029;
    font-size: 36px;
}
.advantage{
    text-align: center;
}
.choose_card_text{
    position: absolute;
    display: inline-block;
    color: #2A2F35;
    font-size: 28px;
    margin-bottom: 29px;
    margin-top: 29px;
    margin-left: 26px;
}
.choose_img{
    fill: #59BCF9;
    display: inline-block;
    height:44px;width:auto; margin-left:36px; margin-top:25px;
}
.choose_card{
    margin-left: 154px;
    width: 398px;
    height: 98px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 10px #00000029;
}
.choose_text{
    margin-top: 84px;
    font-size: 36px;
    font-weight: bold;
    color: #2A2F35;
    margin-left: 240px;
}
.choose_grey{
    height: 567px;
    width: 100%;
    background: #F8F8F8;
}
.choose{
    height: 732px;
    width: 100%;
    background: white
}
.courier_text{
    font-weight:bold; 
    font-size:28px; 
    color:#2A2F35;
    margin-top: 71px;;
    }
.courier_step{
    text-align: center;
    margin-bottom:217px;
    margin-top:54px; ;
}
.courier_content{
    text-align: center;
}
.courier_title{
    margin-top:113px; 
    color: #2A2F35; 
    text-align:center; 
    font-size:36px;
}

.courier_block{
    height: 692px;
    width: 100%;
    background-color: white;
}
.hero_section{
    height: 992px;
    width: 100%;
    z-index: -1;
}
.hero_content{
    /* width: 300px; */
    margin-top: 157px;
    margin-left: 150px;
    position: absolute;
}
.hero_content1{
width: 612px;
margin-top: 355px;
margin-left: 210px;
text-align: left;
font-size: 36px;
font-weight: normal;
letter-spacing: 0px;
color: #1C2126;
position: absolute;
}
.blue_button{
    margin-top: 494px;
    margin-left: 210px;
    width: 195px;
    height: 76px;
    position: absolute;
    background: #E7F3F5 0% 0% no-repeat padding-box;
    border-radius: 5px;
}
.hero_content2{
/* width: 300px; */
padding-top: 13px;
padding-left: 26px;
text-align: left;
font-size: 36px;
font-weight: normal;
letter-spacing: 0px;
color: #00BEFF;
cursor: pointer;
position: absolute;
}
.scrollHospital{
  height: 150px;
  width: auto;
}
.hospitalContent{
  height:145px;
  overflow:auto;
  background:#fff;
}
@media (max-width: 1622px) {
    .courier_block {
    height: 562px;
    }
    .chooseus_img{
        margin-left: 204px;
    }
 .hospital_list {
    width: 586px;
    height: 648px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 30px #00000029;
    border-radius: 10px;
    margin-top: 36px;
}
.hos_image{
    height:350px; 
    width:425px;
 }
}
@media (max-width: 1450px) {
    .hero_content{
         width: 40rem;
    margin-top: 97px;
    margin-left: 110px;
    }
    .hero_content1{
    width: 612px;
    margin-top: 265px;
    margin-left: 160px;
    font-size: 32px;
    }
    .blue_button{
        margin-top: 394px;
        margin-left: 160px;
        width: 195px;
        height: 76px;
    }
    .hero_content2{
    /* width: 300px; */
    padding-top: 13px;
    padding-left: 30px;
    font-size: 32px;
    }
  /* Rules for tablets and smaller viewports */
  .fee_title{
      padding-top: 112px;
  }
  .advantage_text{
      font-size: 20px;
  }
  .adv_image{
    height:171px;
    width:auto;
}
  .choose{
      height: 632px;
  }
  .choose_grey{
    height: 497px;
}
  .courier_text {
    font-size: 22px;
    margin-top: 51px;
}
  .courier_image{
    height:121px; 
    width:auto;
}
  .hospital_image{
    height:445px;
    width:auto;
    float:right;
    margin-top:225px;
    margin-right: 0px;
}
  .choose_card {
    margin-left: 114px;
    width: 328px;
    height: 98px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 10px #00000029;
}
.choose_card_text{
    font-size: 22px;
}
  .hospital_list {
    width: 486px;
    height: 648px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 30px #00000029;
    border-radius: 10px;
    margin-top: 36px;
}
  .hero_img{
          height:692px; 
    width:100%
}
.hero_section {
    height: 692px;
    width: 100%;
    z-index: -1;
}
.hos_image{
    height: 250px;
    width: 295px;
}
.cd_question {
    height: 300px;
}
.choose_text {
    margin-top: 84px;
    margin-left: 140px;
}
.chooseus_img
{
 margin-left:84px;
 height:540px;
}
.fee_pro1 {
    padding-left: 204px;
}
.fee_free{
    width: 888px;
}
.courier_block{
    height: 492px;
}
.courier_step {
    margin-bottom: 17px;
    margin-top: 54px;
}
.advantage_card {
    height: 265px;
    width: 297px;
    padding-top: 32px;
}
}
@media (max-width: 1100px) {
  /* Rules for tablets and smaller viewports */
  /* .choose_text {
      font-size: 26px !important;
    margin-top: 64px;
    margin-left: 44px;
} */
  /* .chooseus_img{
    margin-left: 44px;
    height: 340px;
} */
.hero_content{
        width: 18rem;
    margin-top: 120px;
    margin-left: 85px;
}
.hero_content1{
width: 307px;
margin-top: 205px;
margin-left: 110px;
font-size: 22px;
}
.blue_button{
    margin-top: 304px;
    margin-left: 110px;
    width: 135px;
    height: 56px;
}
.hero_content2{
/* width: 300px; */
padding-top: 13px;
padding-left: 26px;
font-size: 22px;
}
.advantage_text {
    font-size: 18px !important
}
.adv_image{
    height: 100px;
}
.mt-107{
    margin-top: 17px;
}
.advantage_card {
    height: 205px;
    width: 197px;}
.choose_grey{
    height: 467px;
}
.choose{
    height: 1132px;
}
.hospital_list {
    width: 356px;
    height: 548px;
    margin-left: 38px ;
    }
    .hospital_scroll
    {
    height: 548px;
    }
  .courier_title {
    margin-top: 73px;
    }
  .cd_question {
    height: 210px;
}
  .hos_image {
    height: 170px;
    width: 214px;
}
  .hero_section{
    height: 522px;
    }
  .hero_img{
    height: 522px;
    }
  .fee_pro1{
      padding-left: 104px;
  }
 .fee_free{
     width: 588px;
 }
 .choose_card{
    margin-left: 214px;}
}
@media (max-width: 713px){
.hero_content{
    /* width: 300px; */
    margin-top: 37px;
    margin-left: 85px;
}
.hero_content1{
width: 307px;
margin-top: 115px;
margin-left: 110px;
font-size: 18px;
}
.blue_button{
    margin-top: 194px;
    margin-left: 110px;
    width: 95px;
    height: 36px;
}
.hero_content2{
/* width: 300px; */
padding-top: 6px;
padding-left: 14px;
font-size: 18px;
}
.hero_img {
    height: 322px;
}
.hero_section{
    height: 322px;
}
.hos_image {
    height: 104px;
    width: 132px;
}
.cd_question {
    height: 135px;
}
.courier_title {
    margin-top: 53px;
    font-size: 24px !important;}
    .courier_image {
    height: 72px;} .courier_text{font-size: 8px !important; margin-top: 11px;}
    .courier_block{height: 262px;} .choose_text{font-size: 18px !important; margin-top: 11px;margin-left: 31px;}
    .choose_card{margin-left: 64px;} .choose{height: 772px;} .choose_grey {
    height: 207px;} .advantage_text1{font-size: 14px !important;} .advantage_text2{font-size: 24px !important;} .advantage_text3{font-size: 14px !important;}
    .chooseus_img{height: 280px;} .mt-107{margin-top: 0rem;}.advantage_text {
    font-size: 10px !important;} .advantage_card {height: 205px; width: 117px; margin-top: 32px;}.fee_title {
    padding-top: 42px;font-size: 24px !important; padding-left: 170px;}.fee_free{
    width: 358px;} .fee{height: 517px;} .hospital_image{display: none;}
    .fee_free {
    width: 358px;
    height: 78px;
    margin-top: 40px;
}
.fee_pro {
    font-size: 18px;
    padding-left: 28px;
    padding-top: 28px;
}.fee_pro1 {
    font-size: 24px !important;
    padding-left: 98px;
    padding-top: 22px;
} .card_content{font-size: 24px !important;}
.card_title {
    font-size: 12px;
    padding-top: 28px;
} .card_subtitle{
    font-size: 12px;
}.card{
    height: 202px;
}
.col-6 {
    flex: 0 0 50%;
    max-width: 100%;
}.hospital_title {
    font-size: 26px;
    margin-top: 0px;
    padding-left: 30px;
}
.hospital_list {
    width: 340px;
    margin-left: 48px;
    height: 448px;
}
.hospital_outline {
    height: 357px;
}
.hospitalNames2{
    height: 55px;}.hospital_scroll{height: 448px;}
.hospital_name{
    padding-top: 16px;
    font-size: 16px;
}.hospital_block {
    height: 606px;
}
}
@media (max-width: 464px){
    .adv_image {
    height: 50px;
}
.hero_content{
    margin-top: 27px;
    margin-left: 0px;
}
.hero_content1{
    width: 187px;
    margin-top: 105px;
    margin-left: 25px;
    font-size: 12px;
}
.blue_button{
        margin-top: 144px;
    margin-left: 25px;
    width: 85px;
    height: 26px;
}
.hero_content2{
    padding-top: 5px;
    padding-left: 18px;
    font-size: 12px;
}
.hero_img {
    height: 252px;
}
.hero_section{
    height: 252px;
}
.hos_image {
    height: 78px;
    width: 104px;
}
.cd_question {
    height: 95px;
}
.courier_title {
    margin-top: 23px;
    font-size: 20px !important;}
    .courier_step{
    margin-top: 26px;}    
    .courier_image {
    height: 42px;} 
    .choose_card_text{
    font-size: 12px;
    margin-bottom: 8px;
    margin-top: 4px;
    margin-left: 6px;
}
.mt-30{
    margin-top: 10px;
}
.mt-107{
    margin-top: 1rem;
}
.courier_text{font-size: 8px !important; margin-top: 11px;}
.courier_block{height: 192px;} 
.choose_text{font-size: 18px !important; margin-top: 11px;margin-left: 31px;}
.choose_card{margin-left: 0px; width: 138px; height: 29px;}
.choose_img{height: 17px; margin-left: 8px; margin-top: 5px;} 
.choose{height: 232px;} .choose_grey {
height: 157px;} 
.advantage_text1{font-size: 14px !important;} 
.advantage_text2{font-size: 24px !important;} 
.advantage_text3{font-size: 14px !important;}
.chooseus_img{height: 150px; margin-left: 0px;} 
.advantage_text {
font-size: 8px !important;} 
.advantage_card {height: 135px; width: 78px; margin-top: 22px; padding-top: 22px;}
.fee_title {
padding-top: 32px;font-size: 20px !important; padding-left: 150px;}
.col-2 {
    padding: 2px;}
.fee_free {
width: 228px;
height: 48px;
}.fee{height: 387px;} .hospital_image{display: none;}
.fee_pro {
    font-size: 12px;
    padding-left: 18px;
    padding-top: 15px;
}.fee_pro1 {
    font-size: 14px !important;
    padding-left: 58px;
    padding-top: 12px;
} .card_content{font-size: 8px !important;
padding-top: 22px;}
.card_title {
    font-size: 8px;
    padding-top: 8px;
} .card_subtitle{
    font-size: 8px;
    padding-top: 22px;
}.card{
    height: 130px;
}
/* .col {
    flex-grow: 0;
} */
.hospital_title {
    font-size: 26px;
    margin-top: 0px;
    padding-left: 30px;
}
.hospital_list {
    width: 320px;
    margin-left: 36px;
    height: 348px;
}

.hospital_outline {
    height: 357px;
}
.hospitalNames2{
    height: 55px;}
.hospital_scroll
    {height: 348px;}
.hospital_name{
    padding-top: 16px;
    font-size: 16px;
}.hospital_block {
    height: 506px;
}
}
</style>

